// extracted by mini-css-extract-plugin
module.exports = {"page":"FairHousing_page__KuAD6","page__image":"FairHousing_page__image__1luEI","page__content":"FairHousing_page__content__3CcmK"};